<div class="flex justify-content-center gap-2 surface-ground border-none absolute z-10000">
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
    <p-blockUI [blocked]="blockedDocument">
        <ng-template pTemplate="content">
            <p-progressSpinner></p-progressSpinner>
        </ng-template>
    </p-blockUI>
</div>
